<template>
  <div class="order-detail-back">
    <loading v-show="showLoading"></loading>
    <div v-show="!showLoading">

      <!--物流-->
      <div class="order-detail-logistics">
        <div class="order-logistics-left">
          <img src="@/images/icon_package@3x.png"/>
        </div>
        <div class="order-logistics-right">
          <div class="order-logistics-status">
            {{orderDetail.statusName}}
          </div>
          <div class="order-logistics-time">
            {{orderDetail.latestStateDate|formatDate}}
          </div>
        </div>
      </div>

      <!--收获地址-->
      <div class="order-detail-address">
        <div class="order-address-left">
          <img src="@/images/icon_Positioning@3x.png"/>
        </div>
        <div class="order-address-right">
          <div class="order-address-phone">
            {{orderDetail.postalAddress.toName}}  {{orderDetail.postalAddress.contactNumber}}
          </div>
          <div class="order-address-address">
            {{orderDetail.postalAddress.province + orderDetail.postalAddress.city + orderDetail.postalAddress.district + orderDetail.postalAddress.address1}}
          </div>
        </div>
      </div>

      <!--商品列表-->
      <div class="order-list-goods" v-if="orderDetail.productList">
        <div class="order-list-goods-each" v-for="(goods,index) in orderDetail.productList">
          <div class="order-list-goods-left">
            <van-image :src="goods.imgUrl" fit="cover">
              <template v-slot:error></template>
            </van-image>
          </div>
          <div class="order-list-goods-right">
            <div class="order-list-goods-name">
              {{goods.productName}}
            </div>
            <div class="order-list-goods-div">
              <div class="order-list-goods-spec" v-show="goods.productFeatureList.length>0">
                尺寸:{{goods.productFeat}}
                <!--尺寸:<span v-for="(feat,index) in goods.productFeatureList">{{feat+','}}</span>-->
              </div>
              <div class="order-list-goods-num">
                x{{goods.quantity}}
              </div>
            </div>
            <div class="order-list-goods-div-bottom">
              <div class="order-list-goods-price">
                ¥{{goods.price}}
              </div>
            </div>
            <div class="order-list-goods-status">
              <div class="order-list-goods-spec">
                {{goods.productStatusName}}
              </div>
              <div class="order-list-total-button margin-top" v-show="goods.isReview==0" v-if="goods.productStatusName=='已完成'||goods.productStatusName=='待评价'" @click.stop="goEval(orderDetail.orderId,goods.productId,goods,goods.orderItemSeqId)">
                <button class="order-list-button-choice">去评价</button>
              </div>
              <!--<div class="order-list-total-button margin-top" v-if="goods.productStatusName=='待收货'||goods.productStatusName=='已发货'" @click.stop="goEval(orderDetail.orderId)">-->
              <!--<button class="order-list-button-choice">去评价</button>-->
              <!--</div>-->
            </div>
          </div>
        </div>
      </div>

      <!--订单价格-->
      <div class="order-price-div" v-if="orderDetail.price">
        <div class="order-price-each">
          <div class="order-price-title">
            商品总价
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.productCountPrice}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            运费
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.price.partyPrice}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            立减
          </div>
          <div class="order-price-value">
            {{orderDetail.price.productPromoPrice.toFixed(2)}}
          </div>
        </div>
        <div class="order-price-each">
          <div class="order-price-title">
            实付款
          </div>
          <div class="order-price-value">
            ￥{{orderDetail.price.totalPrice}}
          </div>
        </div>
      </div>

      <!--订单信息-->
      <div class="order-detail">
        <div class="order-detail-each">
          <div>
            订单编号：{{orderDetail.orderId}}
          </div>
          <div>
            <button></button>
          </div>
        </div>
        <div class="order-detail-each" v-if="cardType=='entityCard'">
          <div>
            卡号：{{orderDetail.orderDate|formatDate}}
          </div>
        </div>
        <div class="order-detail-each">
          <div>
            下单时间：{{orderDetail.orderDate|formatDate}}
          </div>
        </div>
        <div class="order-detail-each" v-if="orderDetail.paymentMethod">
          <div>
            支付方式：{{orderDetail.paymentMethod.description}}
          </div>
        </div>
        <div class="order-detail-each">
          <div>
            支付时间：{{orderDetail.paymentDate|formatDate}}
          </div>
        </div>
      </div>

    </div>

    <div class="order-detail-footer">
      <button class="order-list-button-choice" v-if="orderDetail.statusName=='待付款'" @click.stop="goPay(orderDetail.orderId,orderDetail.price.totalPrice)">立即付款</button>
      <!--<button class="order-list-button-choice" v-if="orderDetail.statusName=='已发货'||orderDetail.statusName=='部分发货'||orderDetail.statusName=='全部发货'||orderDetail.statusName=='部分收货'||orderDetail.statusName=='待收货'" @click.stop="goSure(orderDetail.orderId,orderDetail.shipmentId)">确认收货</button>-->
      <button class="order-list-button-noChoice" v-if="orderDetail.statusName=='待付款'" @click.stop="goCanel(orderDetail.orderId)">取消订单</button>
      <button class="order-list-button-choice" v-if="orderDetail.statusName=='已发货'||orderDetail.statusName=='部分发货'||orderDetail.statusName=='全部发货'||orderDetail.statusName=='部分收货'||orderDetail.statusName=='待收货'" @click.stop="search()">查看包裹</button>
      <!--<button class="order-list-button-noChoice" v-if="orderDetail.statusName=='已发货'||orderDetail.statusName=='部分发货'||orderDetail.statusName=='全部发货'||orderDetail.statusName=='部分收货'||orderDetail.statusName=='待收货'" @click.stop="goLog(order.orderId,order.shipmentId)">查看物流</button>-->
      <!--<button class="order-list-button-choice" v-if="statusName=='已完成'" @click.stop="goEval(order.orderId)">去评价</button>-->
    </div>

  </div>
</template>

<script>

  import Vue from 'vue'
  import { storeName,prodCatalogId,severUrl,shareOnlineUrl,paymentUrl } from '@/router/Constant'
  import { getOrderInfo,orderCancel,confirmOrderRecive,weixinPays,cloudPays} from '@/router/api'
  import { NavBar, Image, Grid, Tabbar, Toast,Dialog} from 'vant'
  import loading from '@/components/page/common/loading.vue'
  import { setStore,getStore,getCookie,setCookie } from '@/utils/mUtil';

  export default {
    name: "orderDetailExchange",
    data(){
      return{
        showLoading:true,
        orderId:this.$route.query.orderId,
        status:this.$route.query.status,
        statusName:this.$route.query.statusName,
        token:getStore('externalLoginKey'),
        orderDetail:{},
        productStoreId:this.$route.query.productStoreId,
        cardType:this.$route.query.cardType,
        payMap:{}
      }
    },
    mounted(){
      document.documentElement.scrollTop = 0
      this.showLoading = false
      this.initData()
    },
    components:{
      [NavBar.name]: NavBar,
      [Image.name]: Image,
      [Grid.name]: Grid,
      [Tabbar.name]: Tabbar,
      [Toast.name]: Toast,
      loading,
      [Dialog.Component.name]: Dialog.Component,
    },
    filters: {
      formatDate: function (value) {
        if(value!=null&&value!=''&&value!=undefined ){
          let date = new Date(value)
          let y = date.getFullYear()
          let MM = date.getMonth() + 1
          MM = MM < 10 ? ('0' + MM) : MM
          let d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          let h = date.getHours();
          h = h < 10 ? ('0' + h) : h;
          let m = date.getMinutes();
          m = m < 10 ? ('0' + m) : m;
          let s = date.getSeconds();
          s = s < 10 ? ('0' + s) : s;
          return y + '-' + MM + '-' + d+'  '+h+':'+m
        }else{
          return ''
        }

      }
    },
    methods:{
      async initData() {
        this.getOrderDetail();
      },

      getOrderDetail:function () {
        let params = {
          statusName:this.statusName,
          orderId:this.orderId,
          status:this.status,
          productStoreId:this.productStoreId,
          externalLoginKey:this.token
        }
        getOrderInfo(params)
          .then(res => {
            console.log(res);
            if(res._ERROR_MESSAGE_==undefined){
              this.orderDetail = res.orderList[0]
              for(var i = 0;i<this.orderDetail.productList.length;i++){
                var feat = ''
                for(var m =0;m<this.orderDetail.productList[i].productFeatureList.length;m++){
                  feat += this.orderDetail.productList[i].productFeatureList[m]+','
                }
                this.orderDetail.productList[i].productFeat = feat.substring(0,feat.length-1)
              }
            }else{
              Toast(res._ERROR_MESSAGE_)
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      //跳转至评价页面
      goEval:function (orderId,goodsId,goods,orderItemSeqId) {
        setStore("goods",goods)
        this.$router.push({name:'orderEvaluation',query:{orderId:orderId,productId:goodsId,orderItemSeqId:orderItemSeqId}})
      },

      // 用户支付
      goPay:function (orderId,totalPrice) {
        Dialog.confirm({
          title: '支付订单',
          message: '确认要支付该订单吗?'
        }).then(() => {
          console.log(paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey'))
          wx.miniProgram.navigateTo({url:paymentUrl+'?orderId='+orderId+'&totalPrice='+totalPrice+'&externalLoginKey='+getStore('externalLoginKey')})

          // let params = {
          //   orderId:orderId,
          //   externalLoginKey:this.token
          // }
          // weixinPays(params)
          //   .then(res => {
          //     console.log(res);
          //     if(!res._EVENT_MESSAGE_){
          //
          //       // this.scanCode = res.scanCode
          //       // console.log("scanCode========="+this.scanCode)
          //       // window.location.href = this.scanCode
          //
          //       this.payMap = res.payMap
          //       if (typeof WeixinJSBridge == "undefined"){
          //         if( document.addEventListener ){
          //           document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady(), false);
          //         }else if (document.attachEvent){
          //           document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady());
          //           document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady());
          //         }
          //       }else{
          //         this.onBridgeReady();
          //       }
          //     }else{
          //       Toast({message:'获取参数失败'})
          //     }
          //
          //   })
          //   .catch(err => {
          //     this.showLoading = false
          //     console.log(err);
          //   });
        }).catch(() => {
          // on cancel
        });

      },

      //支付参数获取成功后掉取方法
      onBridgeReady:function(){
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', {
            "appId":this.payMap.appId,     //公众号名称，由商户传入
            "timeStamp":this.payMap.timeStamp,         //时间戳，自1970年以来的秒数
            "nonceStr":this.payMap.nonceStr, //随机串
            "package":this.payMap.package,
            "signType":this.payMap.signType,         //微信签名方式：
            "paySign":this.payMap.paySign //微信签名
          },
          function(res){
            if(res.err_msg == "get_brand_wcpay_request:ok" ){
              // 使用以上方式判断前端返回,微信团队郑重提示：
              //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              Toast({message:'支付成功'})
              // window.location.replace(severUrl + "/#/orderList")
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
              this.$router.back(-1)
            }else if(res.err_msg == "get_brand_wcpay_request:cancel"){
              Toast({message:'取消成功'})
              // window.location.replace(severUrl + "/#/orderList")
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }else if(res.err_msg == "get_brand_wcpay_request:fail"){
              Toast({message:'支付失败'})
              setTimeout(() => {
                window.location.href = shareOnlineUrl + "orderList?&externalLoginKey="+getStore('externalLoginKey')
              }, 3000);
            }
          });
      },

      //用户取消订单
      goCanel:function (orderId) {
        Dialog.confirm({
          title: '取消订单',
          message: '确认要取消该订单吗?'
        }).then(() => {
          let params = {
            productStoreId:this.productStoreId,
            orderId:orderId,
            externalLoginKey:this.token
          }
          orderCancel(params)
            .then(res => {
              console.log(res);
              if(res._EVENT_MESSAGE_!=undefined||res._EVENT_MESSAGE_!=null){
                Toast(res._EVENT_MESSAGE_)
              }else{
                Toast('取消订单成功')
                this.$router.back(-1)
              }
            })
            .catch(err => {
              console.log(err);
            });
        }).catch(() => {
          // on cancel
        });

      },

      //用户确认收货
      goSure:function (orderId,shipmentId) {
        Dialog.confirm({
          title: '确认收货',
          message: '确认收到该宝贝了吗?'
        }).then(() => {
          let params = {
            productStoreId:this.productStoreId,
            orderId:orderId,
            externalLoginKey:this.token,
            shipmentId:shipmentId
          }
          confirmOrderRecive(params)
            .then(res => {
              console.log(res);
              if(res._ERROR_MESSAGE_!=undefined){
                Toast(res._ERROR_MESSAGE_)
              }else{
                Toast('确认收货成功')
                this.orderList = []
                this.getOrderList()
              }
            })
            .catch(err => {
              console.log(err);
            });
        }).catch(() => {
          // on cancel
        });
      },

      //用户查看物流
      search:function () {
        setStore('status',3)
        this.$router.push({name:'orderList'})
      }
    }
  }
</script>

<style>
  .order-detail-back{
    background-color: #F8F8F8;
  }

  .nav_bar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    position: fixed;
    z-index: 99;
    width: 100%;
    background: white;
    opacity: 1;
    border-bottom: 1px solid #E1E1E1;
    display: block;
  }
  .nav_bar_left_item {
    padding-top: 0.3rem;
    width:3rem;
  }
  .nav_item_btn {
    width: 1.25rem;height: 1.25rem;
  }
  .order-bar-title{
    width:calc(100% - 3rem);
    text-align: center;
    font-size: 1rem;
    color:#333312;
    height: 2rem;
    line-height: 2rem;
  }

  .order-detail-logistics{
    width:100%;
    background-color: white;
    /*padding-top: 3rem;*/
    margin-bottom: 0.625rem;
  }
  .order-logistics-left{
    display: inline-block;
    vertical-align: top;
    margin-left: 1rem;
    margin-top: 2rem;
    width:1.25rem;
    margin-right: 0.5rem;
  }
  .order-logistics-left img{
    width:1.25rem;
    height: 0.9375rem;
  }
  .order-logistics-right{
    display: inline-block;
    vertical-align: top;
    margin-top: 0.90625rem;
    width:calc(100% -  4rem);
    padding-bottom: 0.90625rem;
  }
  .order-logistics-status{
    color:#33312E;
    font-size:0.96875rem;
    margin-bottom: 0.5rem;
  }
  .order-logistics-time{
    color:#666666;
    font-size: 0.6875rem;
  }
  .order-detail-address{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
    /*padding-top: 3rem;*/
  }
  .order-address-left{
    display: inline-block;
    vertical-align: top;
    margin-left: 1rem;
    margin-top: 2rem;
    width:1.25rem;
    margin-right: 0.5rem;
  }
  .order-address-left img{
    width:1.03125rem;
    height: 1.25rem;
  }
  .order-address-right{
    display: inline-block;
    vertical-align: top;
    margin-top: 0.90625rem;
    width:calc(100% -  4rem);
    padding-bottom: 0.90625rem;
  }
  .order-address-phone{
    color: #33312E;
    font-size: 0.96875rem;
    margin-bottom: 0.875rem;
  }
  .order-address-address{
    color: #9E9E9E;
    font-size: 0.875rem;
  }

  .order-list-goods{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .order-list-goods-each{
    width:100%;
    border-bottom: 1px solid #e7e7e7;
    padding-bottom: 0.9375rem;
    padding-top: 0.9375rem;
  }
  .order-list-goods-left{
    display: inline-block;
    vertical-align: top;
    height: 5rem;
    margin-left: 1rem;
    margin-right:0.6875rem;
  }
  .order-list-goods-left .van-image{
    width:5rem;
    height: 5rem;
  }
  .order-list-goods-right{
    width:calc(100% - 8rem);
    display: inline-block;
    vertical-align: top;
  }
  .order-list-goods-name{
    font-size: 0.875rem;
    color:#333;
    line-height: 1.25rem;
  }
  .order-list-goods-div{
    width:100%;
    min-height: 1.25rem;
    line-height: 1.25rem;
    margin-bottom: 0.25rem;
  }
  .order-list-goods-spec{
    display: inline-block;
    vertical-align: top;
    color:#9E9E9E;
    font-size: 0.75rem;
  }
  .order-list-goods-num{
    float: right;
    vertical-align: top;
    color:#33312E;
    font-size: 0.9375rem;
  }
  .order-list-goods-div-bottom{
    width:100%;
  }
  .order-list-goods-price{
    color:#EB84AB;
    font-size: 1rem;
    display: inline-block;
    vertical-align: top;
  }
  .order-list-goods-div-bottom button{
    float: right;
    width:3.75rem;
    height: 1.40625rem;
    line-height: 1.40625rem;
    border-radius: 0.703125rem;
    color:#EB84AB;
    font-size: 0.75rem;
    text-align: center;
    border: 1px solid #EB84AB;
    padding: 0;
  }
  .order-price-div{
    width:100%;
    background-color: white;
    margin-bottom: 0.625rem;
  }
  .order-price-each{
    width:21.4375rem;
    border-bottom: 1px solid #E7E7E7;
    margin: 0 auto;
    height: 2.65625rem;
    line-height: 2.65265rem;
    font-size: 0.84375rem;
    color:#333312;
    background-color: white;
  }
  .order-price-title{
    float: left;
  }
  .order-price-value{
    float: right;
  }
  .order-detail{
    width:100%;
    background-color: white;
    margin-bottom: 3.75rem;
  }
  .order-detail-each{
    width:21.4375rem;
    margin: 0 auto;
    background-color: white;
    height: 2rem;
    line-height: 2rem;
  }
  .order-detail-each div{
    font-size: 0.78125rem;
    color:#33312E;
  }
  .order-detail-footer{
    width:100%;
    position: fixed;
    bottom: 0;
    z-index: 99;
    background-color: white;
    border-top: 1px solid #E7E7E7;
    height: 3.75rem;
    line-height: 3.75rem;
  }
  .order-detail-footer button{
    width:5rem;
    height: 1.875rem;
    line-height: 1.875rem;
    border-radius: 0.9375rem;
    float: right;
    margin-right: 1rem;
    margin-top: 0.9375rem;
    font-size: 0.84375rem;
    text-align: center;
    padding: 0;
  }
  .order-list-button-choice{
    border: 1px solid #EB84AB;
    color:#EB84AB;
  }
  .order-list-button-noChoice{
    border: 1px solid #9E9E9E;
    color:#9E9E9E;
  }
  .order-list-total-button{
    float: right;
    margin-top: 0.5rem;
  }
  .margin-top{
    margin-top: 0.2rem;
  }
  .order-list-total-button button{
    width:3.75rem;
    height: 1.40625rem;
    border-radius: 0.703125rem;
    float: right;
    font-size: 0.71825rem;
    text-align: center;
    line-height: 1.40625rem;
    padding: 0;
    margin-left: 0.625rem;
  }
  .order-list-goods-status{
    height: 1.875rem;
    line-height: 1.875rem;
  }




</style>



// WEBPACK FOOTER //
// src/components/page/mine/orderDetailExchange.vue